export const FLOATING_HELP_BUTTON_TEXTS = {
    HEADING: 'Got a question or need support?',
    BODY_PREFIX: 'Need help with pricing, eligibility, or group bookings? Visit our',
    CONTACT_LINK_LABEL: 'Contact Page',
    FAQ_LINK_LABEL: "FAQ's",
    FAQ_CONJUNCTION: 'or',
    ARIA_DIALOG: 'Help and support',
    ARIA_OPEN: 'Open help',
    ARIA_CLOSE: 'Close help',
} as const;
